import { STEPS } from "../../data/mock";

export const Steps = () => {
  return (
    <section id="how-it-works" className="py-16 sm:py-24" data-testid="steps-section">
      <div className="mx-auto max-w-6xl px-4">
        <p className="text-center text-xs uppercase tracking-[0.3em] text-[#2f7fff] mb-4">How it works</p>
        <h2 className="font-heading text-center text-3xl sm:text-4xl uppercase tracking-tight text-white mb-14">
          Four steps from zero to <span className="text-gradient-blue">first sale.</span>
        </h2>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step) => (
            <div
              key={step.number}
              className="rounded-2xl border border-white/10 bg-[#0b0d10] p-6 transition-colors hover:border-[#2f7fff]/40"
              data-testid={`step-card-${step.number}`}
            >
              <span className="font-heading text-4xl text-gradient-blue">{step.number}</span>
              <h3 className="mt-5 text-base md:text-lg font-semibold text-white">{step.title}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
